import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { v4 as uuid } from 'uuid';
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../actions/InstallationActions";
import { useState } from 'react';


export function InstallationCalendarDayView(props) {
    const { setView } = props;
    const dispatch = useDispatch();
    const eventList = useSelector((state) => state.installerListVehicleEvents);

    const [selectedSlot, setSelectedSlot] = useState(null);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false); // added state variable
    const [showSubmitButton, setShowSubmitButton] = useState(false);


    const handleUnselect = () => {
        
        setShowSubmitButton(false);
        
    };

    const handleBackClick = () => {
        
        setView('installerListView');
        
    };

    const makeEvent = (info) => {
        if (!info.start || !info.end) {
            return;
        }
        const start = info.startStr;
        const end = info.endStr;
        setSelectedSlot({      
            startStr: start,
            endStr: end,
            
        });     
        setShowSubmitButton(true);
        setShowSuccessMessage(false);
    };

    const handleSubmit = () => {
        const unique_id = uuid();
        const event = {
            eventID: unique_id,
            eventType: 'assigned installer',
            dateCreated: new Date().toJSON().slice(0, 10),
            start: selectedSlot.startStr,
            end: selectedSlot.endStr,            
            title: `Installer ${props.installer} assigned to Vehicle ${props.vehicle}`,
            vehicleID: props.vehicle,
            installerID: props.installerId,
        };     
        dispatch(actions.InstallerListVehicleEventsNewEvent(props.installerId, event));
        dispatch(actions.jobAssigned('unassigned',props.job))
        setShowSubmitButton(false);
        setShowSuccessMessage(true);
       
    };

    return (
        <div id="calendar-container" className="page-section">
            <div className="container installer-header calendar-header">
                <button className="btn btn-secondary back-button" onClick={handleBackClick}>
                    <span className="back-button-arrow"></span> Back
                </button>
                <h2 className="time-title" >Select Time Slot</h2>
                <button
                    className="btn btn-primary calendar-button"
                    style={{
                        display: !showSuccessMessage ? "inline-block" : "none",
                        visibility: showSubmitButton ? "visible" : "hidden",
                        
                    }}
                    onClick={handleSubmit}
                >
                    Submit
                </button>
                {showSuccessMessage && <h5>Success <br/>  Event created!</h5>}
            </div>
            
            <div className="calendar-container">
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView='timeGridDay' // always show day view
                    initialDate={props.date}
                    selectable= {true} 
                    selectMirror={true}
                    allDaySlot={false}
                    headerToolbar={{ start: '', center: 'title', end: '' }} // remove navigation buttons
                    contentHeight="auto"
                    businessHours={[
                        { daysOfWeek: [1, 2, 3, 4, 5], startTime: '7:00', endTime: '16:00' },
                        { daysOfWeek: [6], startTime: '7:00', endTime: '13:00' },
                    ]}
                    dateClick={makeEvent} // use makeEvent for both dateClick and select
                    select={makeEvent}
                    events={eventList}
                    selectMinDistance={1}
                    unselect={handleUnselect}                
                />
               
            </div>

        </div>
    );
}

